define('viewmodels/modals/dialogs/TrophiesDialog',[
   'knockout'
], function (ko) {

    function TrophiesDialog(dialog, adventureFieldFetcher, adventure) {
        var self = this;

        self.trophiesHeading = adventureFieldFetcher('trophies_heading');
        self.trophies = ko.pureComputed(function () {
            return adventure().latestTrophies(24);
        });
        self.dialog = dialog;
        self.title = self.trophiesHeading;
    }

    TrophiesDialog.prototype.show = function () {
        var self = this;

        return self.dialog.showDialog(self);
    };

    TrophiesDialog.prototype.close = function () {
        var self = this;

        self.dialog.close(self);
    };

    return TrophiesDialog;
});

